import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 0.75rem;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  background: white;
  border-radius: 0.75rem;
  padding: 0.75rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  text-align: center;
  
  h2 {
    margin: 0;
    color: #495057;
    font-size: 1.15rem;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .pending-count {
    background: #ffc107;
    color: #856404;
    padding: 0.25rem 0.75rem;
    border-radius: 999px;
    font-weight: 700;
    display: inline-block;
    font-size: 0.95rem;
  }
  
  .pending-label {
    color: #6c757d;
    font-size: 0.95rem;
  }
  
  @media (max-width: 768px) {
    padding: 0.75rem;
    
    h2 {
      font-size: 1.1rem;
    }
    
    .pending-count {
      font-size: 0.9rem;
      padding: 0.15rem 0.4rem;
    }
  }
`;

export const StyledComponents = {
  SearchInput: styled.input`
    padding: 0.6rem 0.75rem;
    border: 2px solid #e9ecef;
    border-radius: 0.5rem;
    font-size: 0.95rem;
    transition: all 0.2s;
    width: 100%;
    
    &:focus {
      outline: none;
      border-color: #86b7fe;
      box-shadow: 0 0 3px rgba(13, 110, 253, 0.25);
    }
    
    &::placeholder {
      color: #6c757d;
    }
  `,
  
  SearchBar: styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 0.75rem;
    align-items: stretch;
    flex-wrap: nowrap;
    
    .search-group {
      /* allow groups to shrink correctly inside a flex row */
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      /* make the first group (vendor selector) fixed width so controls stay together */
      &:first-child {
        flex: 0 0 220px;
      }
      
      label {
        font-weight: 600;
        color: #495057;
        font-size: 0.9rem;
        margin-bottom: 0.25rem;
      }
      
    select, input {
      padding: 0.6rem 0.75rem;
      border: 2px solid #e9ecef;
      border-radius: 0.5rem;
      font-size: 0.95rem;
      transition: all 0.2s;
        
        &:focus {
          outline: none;
          border-color: #86b7fe;
          box-shadow: 0 0 3px rgba(13, 110, 253, 0.25);
        }
        
        &::placeholder {
          color: #6c757d;
        }
      }
      
      select {
        cursor: pointer;
      }
      
      input {
        &::placeholder {
          color: #6c757d;
        }
      }
    }
    
    /* Removed: Search actions (Clear button) */
    /* Switch to stacked layout earlier for tablets and small laptops */
    @media (max-width: 992px) {
        /* On small screens stack controls vertically for better usability */
        flex-direction: column;
        gap: 0.75rem;

        /* Make every group full width */
        .search-group {
          flex: 1 1 100%;
          min-width: 0;
        }

        /* Reset the fixed width of the vendor selector so it becomes fluid */
        .search-group:first-child {
          flex: 1 1 100%;
        }

        .search-actions {
          width: 100%;
          justify-content: flex-end;

          /* Make the clear button stretch full width and match input styling on mobile */
          button {
            width: 100%;
            padding: 0.75rem 1rem;
            text-align: center;
          }

          .clear-button {
            background: #ffffff;
            border: 2px solid #e9ecef;
            color: #495057;
            border-radius: 0.5rem;
          }
        }
      }
    }
  `,

  PaymentsContainer: styled.div`
    background: white;
    border-radius: 0.75rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
  `,

  PaymentList: styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 0.25rem;
    
    &::-webkit-scrollbar {
      width: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 4px;
      
      &:hover {
        background: #a8a8a8;
      }
    }
  `,
  
  PaymentCard: styled.div`
    border-bottom: 1px solid #e9ecef;
    padding: 1.0rem;
    transition: all 0.2s ease;
    cursor: pointer;
    
    &:hover {
      background-color: #f8f9fa;
      transform: translateY(-1px);
    }
    
    &:last-child {
      border-bottom: none;
    }
    
    .payment-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 0.75rem;
      
      .left-info {
        flex: 1;
        
        .order-id {
          font-size: 0.9rem;
          color: #6c757d;
          margin-bottom: 0.25rem;
        }
        
        .customer-name {
          font-size: 1.1rem;
          font-weight: 600;
          color: #495057;
          margin-bottom: 0.25rem;
          line-height: 1.3;
        }
        
        .meta-info {
          font-size: 0.9rem;
          color: #6c757d;
        }
      }
      
      .amount-info {
        text-align: right;
        
        .amount {
          font-size: 1.3rem;
          font-weight: 700;
          color: #495057;
          margin-bottom: 0.25rem;
        }
        
        .method {
          font-size: 0.85rem;
          color: #6c757d;
        }
      }
    }
    
    .payment-details {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.5rem;
    }
    
    .notes-section {
      background: #f8f9fa;
      padding: 0.5rem;
      border-radius: 0.375rem;
      border-left: 3px solid #e9ecef;
      font-size: 0.9rem;
      color: #6c757d;
      line-height: 1.3;
    }
    
    .actions {
      display: flex;
      gap: 0.5rem;
    }
    
    button {
      padding: 0.5rem 1rem;
      border: none;
      border-radius: 0.375rem;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 0.9rem;
      
      &.confirm-btn {
        background-color: #28a745;
        color: white;
        
        &:hover {
          background-color: #218838;
        }
        
        &:disabled {
          background-color: #6c757d;
          cursor: not-allowed;
        }
      }
      
      &.reject-btn {
        background-color: #dc3545;
        color: white;
        
        &:hover {
          background-color: #c82333;
        }
        
        &:disabled {
          background-color: #6c757d;
          cursor: not-allowed;
        }
      }
      
      @media (max-width: 768px) {
        flex-direction: column;
        gap: 0.75rem;
        
        button {
          font-size: 0.8rem;
        }
      }
    }
  `,

  EmptyState: styled.div`
    text-align: center;
    padding: 2rem 1.5rem;
    color: #6c757d;
    font-size: 1.1rem;
    background: white;
    border-radius: 0.75rem;
    border: 2px dashed #dee2e6;
    margin: 2rem;
    line-height: 1.4;
  `
};